import React, { useEffect, useState } from "react";
import { Button, DatePicker, Select, Table, Tooltip } from "antd";
import { useNavigate } from "react-router-dom";
import "../../css/common.css";
import { EditOutlined } from "@ant-design/icons";
import { post } from "../../../services/services";
import {
  ApiURL,
  enginglogdownloadPdfUrl,
} from "../../../services/apiConstants";
import VoyageDetails from "../../../components/VoyageDetails";
import { formatDate, formatDateTime } from "../../../utils/dateFormatter";
import useVoyageList from "../../../hooks/useVoyageList";
import { DOWNLOADPDF } from "../../../utils/downloadPdf";
import dayjs from "dayjs";
import { dateRanges } from "../../../Data/data";
import { getAllEntries } from "../../../services/indexedDBService";
const { RangePicker } = DatePicker;

const ListenginelogBook = () => {
  const navigate = useNavigate();
  const { voyageList } = useVoyageList();
  const [page_loader, set_page_loader] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [staff_dashboard, set_staff_dashboard] = useState([]);
  const [voyage_ids, set_voyage_id] = useState("");
  const [voyage_status, set_voyage_status] = useState(true);
  const [dates, setDates] = useState([dayjs().subtract(2, "day"), dayjs()]);
  const [startDate, endDate] = dates?.map((d) => d.format("YYYY-MM-DD")) || [];
  // const [log_Date,set_Log_Date]=useState(null)

  useEffect(() => {
    if (voyageList?.length > 0) {
      const runningVoyage = voyageList.find(
        (voyage) => voyage?.voyage_status === true
      );
      set_voyage_status(runningVoyage?.voyage_status);
      if (runningVoyage) {
        set_voyage_id(runningVoyage.id);
        if (runningVoyage.id) LIST_ENGINE_LOGBOOK_API(runningVoyage.id);
      }
    }
  }, [voyageList]);

  // const LIST_ENGINE_LOGBOOK_API = async (voyage_id) => {
  //   set_page_loader(true);
  //   try {
  //     const FORM_DATA = new FormData();
  //     FORM_DATA.append("voyage_id", voyage_id);
  //     const res = await post(ApiURL.listing_engine_logbook, FORM_DATA);
  //     if (res?.status == true) {
  //       setFilteredData(res.response_data);
  //     } else {
  //       setFilteredData([]);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching Engine Logbook list:", error);
  //     setFilteredData([]);
  //   } finally {
  //     set_page_loader(false);
  //   }
  // };

  // useEffect(() => {
  //   LIST_ENGINE_LOGBOOK_API();
  // }, []);

  const LIST_ENGINE_LOGBOOK_API = async (voyage_id) => {
    set_page_loader(true);
    try {
      if (!navigator.onLine) {
        const cachedData = await getAllEntries();
        console.warn("Offline mode: Loaded Engine Logbook from IndexedDB.");
        setFilteredData(cachedData);
      } else {
        const FORM_DATA = new FormData();
        FORM_DATA.append("voyage_id", voyage_id);
        const res = await post(ApiURL.listing_engine_logbook, FORM_DATA);
        if (res?.status === true) {
          setFilteredData(res.response_data);
        } else {
          setFilteredData([]);
        }
      }
    } catch (error) {
      console.error("Error fetching Engine Logbook list:", error);
      setFilteredData([]);
    } finally {
      set_page_loader(false);
    }
  };

  useEffect(() => {
    const staff_dashboards = JSON.parse(
      localStorage.getItem("staff_dashboard")
    );
    set_staff_dashboard(staff_dashboards);
    if (voyage_ids) LIST_ENGINE_LOGBOOK_API(voyage_ids);
  }, []);

  const columns = [
    {
      title: "Id",
      dataIndex: "eng_log_basic_id",
      align: "center",
      key: "eng_log_basic_id",
      sorter: (a, b) => a.eng_log_basic_id - b.eng_log_basic_id,
    },
    {
      title: "Basic Log status",
      dataIndex: "eng_log_basic",
      align: "center",
      key: "eng_log_basic",
      render: (text, record) => {
        if (record.eng_log_basic === "Completed") {
          return (
            <span className="table-status-activate">
              {record?.eng_log_basic}
            </span>
          );
        } else {
          return (
            <span className="table-status-deactivate">
              {record?.eng_log_basic}
            </span>
          );
        }
      },
    },
    {
      title: "Main Engine Log status",
      dataIndex: "main_eng_log",
      align: "center",
      key: "main_eng_log",
      render: (text, record) => {
        if (record?.main_eng_log === "Completed") {
          return (
            <span className="table-status-activate">
              {record?.main_eng_log}
            </span>
          );
        } else {
          return (
            <span className="table-status-deactivate">
              {record?.main_eng_log}
            </span>
          );
        }
      },
    },
    {
      title: "Auxiliary Engine Log status",
      dataIndex: "aux_eng_log",
      align: "center",
      key: "aux_eng_log",
      render: (text, record) => {
        if (record?.aux_eng_log === "Completed") {
          return (
            <span className="table-status-activate">{record?.aux_eng_log}</span>
          );
        } else {
          return (
            <span className="table-status-deactivate">
              {record?.aux_eng_log}
            </span>
          );
        }
      },
    },
    {
      title: "Auxiliary Machinary Log status",
      dataIndex: "auxi_machinary_log",
      align: "center",
      key: "auxi_machinary_log",
      render: (text, record) => {
        if (record?.auxi_machinary_log === "Completed") {
          return (
            <span className="table-status-activate">
              {record?.auxi_machinary_log}
            </span>
          );
        } else {
          return (
            <span className="table-status-deactivate">
              {record?.auxi_machinary_log}
            </span>
          );
        }
      },
    },
    {
      title: "Cargo Machinary Log status",
      dataIndex: "cargo_machinary_log",
      align: "center",
      key: "cargo_machinary_log",
      render: (text, record) => {
        if (record?.cargo_machinary_log === "Completed") {
          return (
            <span className="table-status-activate">
              {record?.cargo_machinary_log}
            </span>
          );
        } else {
          return (
            <span className="table-status-deactivate">
              {record?.cargo_machinary_log}
            </span>
          );
        }
      },
    },
    {
      title: "Event date & time ",
      dataIndex: "date_time_log",
      align: "center",
      key: "date_time_log",
      render: (text, record) => formatDateTime(record?.date_time_log),
    },
    {
      title: "Created Date",
      dataIndex: "created_at",
      align: "center",
      key: "created_at",
      render: (text, record) => formatDate(record?.created_at),
    },
    {
      title: "Updated Date",
      dataIndex: "updated_at",
      align: "center",
      key: "updated_at",
      render: (text, record) => formatDate(record?.updated_at),
    },

    {
      title: "Action",
      align: "center",
      key: "Action",
      render: (text, record) => {
        return (
          <>
            <Tooltip
              title={
                !voyage_status
                  ? "Editing is disabled when voyage status is inactive."
                  : "Edit"
              }
            >
              <span>
                <Button
                  disabled={!voyage_status}
                  type="primary"
                  size="small"
                  onClick={() =>
                    navigate(
                      `/edit-engine-basic-info/${record?.eng_log_basic_id}`
                    )
                  }
                  style={{ marginRight: "5px" }}
                  icon={<EditOutlined />}
                />
              </span>
            </Tooltip>
          </>
        );
      },
    },
  ];

  return (
    <>
      <VoyageDetails
        staff_dashboard={staff_dashboard?.voyage_details}
        buttonShow={true}
        disabled={!voyage_status}
        buttonProps={{
          text: "Add Logs",
          className: "save_btn",
          onClick: () => navigate("/add-engine-basic-info"),
          onPress: () => navigate("/audit-trail-engine"),
        }}
      />
      <div className="row">
        <div
          className="col-3"
          style={{ marginBottom: "13px", marginLeft: "15px" }}
        >
          <label className="block-label">Select Voyage Id</label>
          <Select
            placeholder="---- Select Voyage Id ----"
            style={{ width: "100%" }}
            value={voyage_ids}
            onChange={(value) => {
              const selectedVoyage = voyageList.find(
                (voyage) => voyage.id === value
              );
              if (selectedVoyage) {
                set_voyage_status(selectedVoyage.voyage_status);
              }
              set_voyage_id(value);
              LIST_ENGINE_LOGBOOK_API(value);
            }}
          >
            {voyageList?.map((voyage) => (
              <Select.Option key={voyage.id} value={voyage.id}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <span>{`Voyage Id: ${voyage.id}`}</span>
                  <span
                    style={{
                      color:
                        voyage.voyage_status === true ? "#FFA500" : "#008000",
                      fontWeight: "550",
                      marginRight: "15px",
                    }}
                  >
                    {voyage.voyage_status === true ? "Running" : "Complete"}
                  </span>
                </div>
              </Select.Option>
            ))}
          </Select>
        </div>

        <div className="col-3"></div>
        <div
          className="col-6"
          style={{ display: "flex", justifyContent: "flex-end" }}
        >
          <div style={{ marginRight: "15px" }}>
            <label className="block-label">Select Start Date & End Date</label>
            <RangePicker
              presets={dateRanges}
              value={dates}
              onChange={setDates}
              format="YYYY-MM-DD"
              style={{ width: 350 }}
              disabledDate={(current) =>
                current && current > dayjs().endOf("day")
              }
            />
          </div>
          <div style={{ alignSelf: "flex-end" }}>
            <Button
              type="primary"
              className="save_btn"
              style={{ color: "white", marginBottom: "13px" }}
              onClick={() =>
                DOWNLOADPDF(
                  enginglogdownloadPdfUrl,
                  voyage_ids,
                  startDate,
                  endDate
                )
              }
            >
              Download Pdf
            </Button>
          </div>
        </div>
      </div>
      <Table
        bordered
        columns={columns}
        dataSource={filteredData}
        pagination={{ pageSize: 10 }}
        rowKey="key"
        loading={page_loader}
        className="custom-table"
      />
    </>
  );
};

export default ListenginelogBook;
